import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator that checks if the date is in a valid range.
 * @param startCtrl The minimal date allowed.
 * @param endCtrl The maximal date allowed.
 * @returns A validator function that checks max. range for a date.
 */
export function dateRangeValidator(startCtrl: AbstractControl | null, endCtrl: AbstractControl | null): ValidatorFn {
	return (): ValidationErrors | null => {
		const start = startCtrl?.value;
		const end = endCtrl?.value;

		if (!start || !end) {
			return null;
		}

		return new Date(end) < new Date(start) ? { dateRangeExceeded: true } : null;
	};
}
